// One of a short row of exclusive answers (No / Yes), as a pill: 2px
// border, bold, the chosen one dark. `base` is the form renderer's exact
// 72 × 39.5 mockup size; `lg` steps the type and padding up for screens
// where the pill is the whole answer.

import type { ReactNode } from "react";

import type { ChoiceSize } from "components/ChoiceCard/ChoiceCard";

const BASE =
  "inline-flex items-center justify-center rounded border-2 font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cantelope/60";

const SIZE: Record<ChoiceSize, string> = {
  base: "h-[39.5px] min-w-[72px] px-4 text-base",
  lg: "min-w-[88px] px-5 py-2.5 text-lg",
};

export function choicePillClass(selected: boolean, size: ChoiceSize): string {
  const state = selected
    ? "border-soil bg-soil text-ivory-light"
    : "border-oat-200 bg-transparent text-soil enabled:hover:border-soil";
  return `${BASE} ${SIZE[size]} ${state}`;
}

export default function ChoicePill({
  selected,
  onSelect,
  size = "base",
  children,
}: {
  selected: boolean;
  onSelect: () => void;
  size?: ChoiceSize;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className={choicePillClass(selected, size)}
      aria-pressed={selected}
      onClick={onSelect}
    >
      {children}
    </button>
  );
}
